import styled from 'styled-components';

export const TitlePage = styled.h1`
  font-weight: normal;
  color: #f1f1f1;
  margin-left: 10px;
  font-size: 17px;
  line-height: 28px;
`;

export const SubTitle = styled.h3`
  color: #616161;
  font-weight: normal;
  font-size: 14px;
`;

export const SubTitleBold = styled.h3`
  color: #616161;
  font-weight: bold;
  font-size: 16px;
`;
